var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-radio',{attrs:{"label":"Bonifico","value":_vm.LISTINGS.PAYMENT_METHOD.BANK_TRANSFER}}),_c('v-radio',{attrs:{"label":"Carta di credito","value":_vm.LISTINGS.PAYMENT_METHOD.CREDIT_CARD}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }